import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-add-products',
  templateUrl: './add-products.component.html',
  styleUrls: ['./add-products.component.scss'],
})
export class AddProductsComponent implements OnInit {
  
  constructor(
    private route:Router,
    private modalCtrl: ModalController) { }
  
  addProduct(){
    this.route.navigate(['my-products/add-product'])
    this.modalCtrl.dismiss()
  }

  ngOnInit() {}

}
